import { ChangeEvent, FC, useEffect, useRef, useState, useCallback, useMemo } from 'react'
import styles from './index.module.scss'


import TrackFlightsCTA from 'the-room-of-requirement/Components/TrackFlightsCTA'
import AirportField from './AirportField'
import {
    debounce,
    getflightsHistory,
    htmlSanitizer,
    isEmpty,
    replaceQueryInUrl,
    resolveKeysInObjectsArrays,
    toQueryString,
    updateHomeSearch,
    isNewInternational
} from '@/utils/general/browserHelper'
import baseFetch from '@/network/baseFetch'
import { HOME_API_ENDPOINTS, REQUEST_METHODS } from '@/constants/network'
import { getApiDomain, getUrlWithArgs } from '@/utils/general/url'
import { ISuggestion } from '@/types/home'
import { Button, Container, Spacer } from '@cleartrip/ct-design-components'
import DateRangePicker from '@/components/oldComponents/DateRangePicker'
import dayjs from 'dayjs'
import { dateDiff, dayDiff, formatDateStandardized, getFormattedDate } from '@/utils/general/date'
import JourneyType from '@/components/home/JourneyType'
import TravellerAndClassDropdown from '@/components/home/TravellersAndClass'
import { FareTypeInterface, FARE_TYPE, returnFareName } from '@/constants/components/fareType'
import { RAVEN_ATTRIBUTE_NAME, RAVEN_EVENT_NAME, RAVEN_PAGE_NAME } from '@/analytics/raven/ravenConstants'
import { Raven } from '@/analytics/raven'
import { useAppDispatch, useAppSelector } from '@/redux/store/hooks'
import { getAbData } from '@/redux/slices/abConfig'
import { fetchVisaDenialEligibilityData, getVisaDenialAvailable, resetVisaDenialState } from '@/redux/slices/visaDenial'
import { GaDataPush, dataLayerGA, getInitialDataLayerParams } from '@/analytics/GA/dataLayerHelper'
import { isUserSignedIn } from '@/utils/general/user'
import Clevertap from '@/analytics/clevertap/index'
import { ACTION_NAMES } from '@/constants/analytics'
import { HomeFormType } from '@/components/home/HomeForm'
import { homePageLoad } from '@/analytics/clevertap/events'
import { defaultAbValues } from '@/constants/base'
import SpecialFaresRow from '@/components/shared/SpecialFaresRow'
import { isCfwFlow } from '@/utils/cfw'
import { ActionMapper } from '@/types'
import { getActionPayload } from '@/utils/general/actions'
import { useRouter } from 'next/router'
import { Statsig } from '@/utils/statsig'
import { getCookie, setCookie } from '@/utils/general/cookie'
import { checkPhoneNumberWhitelisting } from '@/utils/experiment/phoneNumberWhitelisting'
import { checkInternalCTUser } from '@/utils/srp'
import { STATSIG_SPLIT_RT_EXP_NAME } from '@/constants/experiment'
import { EXPLORE_CTA_LABELS } from '@/constants/explore'
import { getPopularAirportSuggestions } from '@/utils/general/uiHelper'
import { getExploreRouteQuery } from '@/utils/explore'
import { createVisaDenialPayload } from '@/utils/homepage/visaDenialHelper'
import { airportSearchBluk } from '@/api/srp'
import ToggleSwitch from '@/components/ToggleSwitch'
import { Typography } from '@cleartrip/ct-design-components'
import { Collapse } from '@/components/Collapse/Collapse'
import { SENTRY_METRICS_CONFIG } from '@/constants/analytics/sentryCountMetrics'
import { countMetric, getHomeSearchMetricAttributes } from '@/utils/analytics/sentry/metrics'
import { trackingPageConstants } from '@/components/FlightTracking/constants'
import { ravenSDKTrigger } from '@/analytics/raven/ravenSDKHelper'
import { getUtmSourceInfo } from '@/utils/common'
export interface queryFormat {
    adults: string
    childs: string
    infants: string
    class: string
    depart_date?: string
    return_date?: string
    from?: string
    to?: string
    intl?: string
}

interface CityState {
    source: string
    destination: string
    sourceCountry: string
    destinationCountry: string
    sCode: string
    dCode: string
    isIntl: string
    departureError: boolean
    arrivalError: boolean
    intl?: string
}
export interface srpQueryObject {
    adults: string
    childs: string
    infants: string
    class: string
    depart_date?: string
    return_date?: string
    from: string
    to: string
    intl: string
    origin: string
    destination: string
    sft: string
    sd: number
    rnd_one: string
    isCfw: boolean
    isFF?: boolean
    isMultiFare?: boolean
    isFFSC?: boolean
    nonStop?: string
    setShowVisaBanner: (arg1: boolean) => void
    setShowBanner: (arg1: boolean) => void
    traffic_source?: string
}

const HomeSearchContainer: FC<HomeFormType> = ({
    query,
    setQuery,
    setShowVisaBanner,
    setShowBanner,
    isExploreEnabled = false,
    offerConfigReady,
}) => {
    const [initialTS, setInitialTS] = useState(new Date().getTime())
    const [popularAirports, setPopularAirports] = useState<ISuggestion[]>([])
    const [airportSearchList, setAirportList] = useState<{
        departure: ISuggestion[]
        arrival: ISuggestion[]
    }>({ departure: [], arrival: [] })
    const departureSearchRef = useRef('')
    const arrivalSearchRef = useRef('')
    let [departure, setDeparture] = useState('')
    const [isIntlSelected, setIsIntlSelected] = useState([false, false])
    let [arrival, setArrival] = useState('')
    const [tripType, setTripSelect] = useState('O')
    const [isCfwSelected, setIsCfwSelected] = useState(false)
    // const [query, setQuery] = useState<queryFormat>({ adults: '1', childs: '0', infants: '0', class: 'Economy' })
    const [fareList, setFareList] = useState(FARE_TYPE)
    const [isIntlArray, setIsIntlArray] = useState([false, false])
    const [activeFare, setActiveFare] = useState('')
    const [cfwModal, setCfwModal] = useState(false)
    const [nonStopFilter, setNonStopFilter] = useState(false)
    const browserHistory = useRouter()
    const [city, setCity] = useState<CityState>({
        source: '',
        destination: '',
        sourceCountry: '',
        destinationCountry: '',
        sCode: '',
        dCode: '',
        isIntl: '',
        departureError: false,
        arrivalError: false
    })
    const [loading, setloading] = useState(false)
    const [toast, setToast] = useState({})
    const [airportSearchBlukResponse, setAirportSearchBlukResponse] = useState<any>(null)
    const abData = useAppSelector(getAbData)
    const [getAbTest, setAbTest] = useState({
        // e_home: 'z', ctUpgrade: 'c',
        ...defaultAbValues
    })
    const globalDispatcher = useAppDispatch()
    const dispatch = useAppDispatch()
    const isVisaDenialAvailable = useAppSelector(getVisaDenialAvailable)
    const { FUNNEL_HOME_LOADED, FUNNEL_SEARCH_CLICKED } = SENTRY_METRICS_CONFIG

    useEffect(() => {
            setCookie({ name: 'ffEnabled', value: 'false' })
            countMetric(FUNNEL_HOME_LOADED, 1)
    },[])

    // Popular From/To list from OfferConfig (popularSearchesPWA), not the airports API.
    // HomeMain loads offerSlot.js and bumps offerConfigReady on onload — seed empty fields then.
    useEffect(() => {
        if (typeof window === 'undefined' || !Array.isArray(window.offerJson)) return

        const list = getPopularAirportSuggestions()
        setPopularAirports(list)
        // Don't overwrite a side the user is already typing/searching in
        setAirportList(prev => ({
            departure: departureSearchRef.current ? prev.departure : list,
            arrival: arrivalSearchRef.current ? prev.arrival : list,
        }))
    }, [offerConfigReady])

    useEffect(() => {
        setInitialTS(new Date().getTime())
        let flightHistory = getflightsHistory()

        const ravenPayLoad = {
            page_name: RAVEN_PAGE_NAME.FLIGHTS_HOME,
            a_utm_source:
                location?.search?.split?.('utm_source=').length > 1
                    ? location?.search?.split?.('utm_source=')?.pop()?.split('&')?.[0]
                    : 'organic',
            page_loadtime: new Date().getTime() - initialTS || 'N/A',
            last_page_name:
                location?.search?.split?.('utm_source=').length > 1
                    ? location?.search?.split?.('utm_source=')?.pop()?.split('&')?.[0]
                    : '',
            search_details_prefilled: localStorage.getItem('fsHistory') ? 'yes' : 'no'
        }
        // if (abData) {
            homePageLoad({ initialLoadTime: initialTS, getAbTest: abData, abhome: abData?.tk_home })
            // Raven.push({ eventName: RAVEN_EVENT_NAME.HOME_PAGELOAD, eventData: ravenPayLoad })
            // setAbTest({ ...getAbTest, ...abData })
        // } else {
        //     homePageLoad({ initialLoadTime: initialTS })
        //     Raven.push({ eventName: RAVEN_EVENT_NAME.HOME_PAGELOAD, eventData: ravenPayLoad })
        // }
         let dataLayerValues = getInitialDataLayerParams('home')
        let dataLayerEventName = 'Home_Page'
        if (window && window.location && window.location.href && window.location.href.indexOf('/flights') > -1) {
            dataLayerValues = getInitialDataLayerParams('flights')
            dataLayerEventName = 'Flights_Home'
        }

        if (!isEmpty(flightHistory)) {
            if (flightHistory[0].rnd_one !== 'MC') {
                const defaultDepartDate = dayjs().add(2, 'day').toDate()
                let date = getFormattedDate(defaultDepartDate, 'DD/MM/YYYY')
                let departDate = flightHistory[0].depart_date
                let returnDate = flightHistory[0].return_date
                let diff = dateDiff(date, departDate, 'DD/MM/YYYY')
                if (diff < 0) {
                    flightHistory[0].depart_date = date
                }
                if (!isEmpty(returnDate)) {
                    diff = dateDiff(date, returnDate, 'DD/MM/YYYY')
                    if (diff < 0) {
                        flightHistory[0].return_date = date
                    }
                }
                setQuery({
                    ...query,
                    ...flightHistory[0]
                })
                setTripSelect(flightHistory[0].rnd_one)
                setDeparture(flightHistory[0].origin)
                setArrival(flightHistory[0].destination)
                setCity({
                    ...city,
                    ...flightHistory[0],
                    sCode: flightHistory[0].from,
                    source: flightHistory[0].sourceCountry,
                    destination: flightHistory[0].destinationCountry,
                    dCode: flightHistory[0].to
                })
                const arrIntl = flightHistory[0].destination?.split(', ')?.pop()?.trim() !== 'IN'
                const depIntl = (flightHistory[0].origin as unknown as string)?.split(', ')?.pop()?.trim() !== 'IN'
                setIsIntlSelected([arrIntl, depIntl])
                if(!(browserHistory?.query?.['airCFW-reactivation'] === 'true')){
                    setIsCfwSelected(flightHistory[0].isCfw)
                }
                setActiveFare(flightHistory[0].sft || "")
            } else if (query.depart_date === 'Invalid Date' || isEmpty(query.depart_date)) {
                setQuery({
                    ...query,
                    depart_date: getFormattedDate(dayjs().add(2, 'day').toDate(), 'DD/MM/YYYY')
                })
            }
        } else if (query.depart_date === 'Invalid Date' || isEmpty(query.depart_date)) {
            setQuery({
                ...query,
                depart_date: getFormattedDate(dayjs().add(2, 'day').toDate(), 'DD/MM/YYYY')
            })
        }
        if(browserHistory?.query?.['airCFW-Introduction'] === 'true'){
            setIsCfwSelected(true)
        }
    }, [])



    useEffect(() => {
        const gaPayload = {
            section: 'Flights'
        }
        GaDataPush('event', ACTION_NAMES.hpPageLandGA, gaPayload)
        dataLayerGA(gaPayload, 'home_page_land')
        // raven event experiment
        let ravenPayload = {
            platform: 'desktop',
            login_status: isUserSignedIn() ? 'yes' : 'no',
            domain: resolveKeysInObjectsArrays(['location', 'hostname'], window),
            vertical: 'air',
            page_name: 'flights_home'
        }
        Raven.push({ eventName: RAVEN_EVENT_NAME.HOME_M_HOMEPAGE_LOAD, eventData: ravenPayload })
        Clevertap.event(ACTION_NAMES.wrHomepageLoad, { ...ravenPayload })
        dataLayerGA({ ...ravenPayload }, ACTION_NAMES.wrHomepageLoad)
        // end of raven event experiment
    }, [])

    useEffect(() => {
        if (city.isIntl === 'y' || (isEmpty(city.isIntl) && city.intl === 'y')) {
            setActiveFare('')
            setFareList(fareFilter(true))
        } else {
            if (parseInt(query.childs) > 0 || parseInt(query.infants) > 0) {
                setFareList(fareFilter(false))
            } else {
                setFareList(fareFilter(true))
            }
        }
    }, [query.childs, query.infants, city])

    function fareFilter(enabled: boolean) {
        const fareType = fareList.map(item => {
            if (item.code === 'senior_citizen' || item.code === 'student') {
                item.active = enabled
                if (!enabled) item.toolTipErrorMsg = `${item.fare} fares are available for adult passengers only. Please de-select children/infant passengers to continue.`
            } else {
                item.active = true
            }
            return item
        })
        return fareType
    }

    // CFW is now supported for international flights too, so selecting an intl
    // sector no longer deselects CFW.

    const timerRefVisaDenial = useRef<number | NodeJS.Timeout | null>(null)
    const hasMadeFirstCallRef = useRef(false)
    const lastVisaDenialParamsRef = useRef<string>('')

    const isAirportSearchBlukLoadingRef = useRef(false)

    // Call airportSearchBluk first, then trigger vasDiscovery with country code from airportSearchBluk response
    useEffect(() => {
        const callAirportSearchBlukAndVasDiscovery = async () => {
            if (!city?.sCode || !city?.dCode || !query?.depart_date) {
                // Query is incomplete — clear any stale visa-denial result so the
                // banner from a previous search doesn't linger.
                dispatch(resetVisaDenialState())
                return
            }

            if (tripType === 'R' && !query.return_date) {
                dispatch(resetVisaDenialState())
                return
            }

            // vasDiscovery is only relevant for international sectors. Skip the
            // call entirely for domestic sectors, and clear any stale result so
            // the banner from a previous international search goes away.
            const isIntl = city.isIntl === 'y' || (isEmpty(city.isIntl) && city.intl === 'y')
            if (!isIntl) {
                dispatch(resetVisaDenialState())
                return
            }

            // Create a unique key for this search combination
            const searchKey = `${city.sCode}-${city.dCode}-${query.depart_date}-${query.return_date || ''}-${tripType}`
            
            // Skip if we've already made the call for this exact search
            if (lastVisaDenialParamsRef.current === searchKey) {
                return
            }

            // Prevent multiple simultaneous calls
            if (isAirportSearchBlukLoadingRef.current) {
                return
            }

            isAirportSearchBlukLoadingRef.current = true

            try {
                // Step 1: Call airportSearchBluk first
                let payload = [city.sCode, city.dCode]
                let response = await airportSearchBluk(payload) as any
                const { data, code } = response
                
                if (data && code === 200) {
                    setAirportSearchBlukResponse(data)
                    
                    // Step 2: Create visa denial payload using helper function
                    const visaDenialPayload = createVisaDenialPayload({
                        source: city.sCode,
                        destination: city.dCode,
                        departDate: query.depart_date,
                        returnDate: query.return_date,
                        tripType: tripType,
                        isIntl,
                        isCfw: isCfwSelected,
                        airportSearchBlukResponse: data
                    })

                    if (visaDenialPayload) {
                        // Mark that we've made the call for this search
                        lastVisaDenialParamsRef.current = searchKey

                        // Dispatch Redux action for vasDiscovery
                        dispatch(fetchVisaDenialEligibilityData(visaDenialPayload))
                    }
                }
            } catch (e) {
                console.log('airportSearchBluk error:', e)
            } finally {
                isAirportSearchBlukLoadingRef.current = false
            }
        }

        // Clear any existing timeout
        if (timerRefVisaDenial.current) {
            clearTimeout(timerRefVisaDenial.current)
        }

        // First call: debounce with 1000ms delay
        // Subsequent calls: immediate (but already guarded by searchKey check above)
        if (!hasMadeFirstCallRef.current) {
            timerRefVisaDenial.current = setTimeout(() => {
                callAirportSearchBlukAndVasDiscovery()
                hasMadeFirstCallRef.current = true
                timerRefVisaDenial.current = null
            }, 1000)
        } else {
            callAirportSearchBlukAndVasDiscovery()
        }

        // Cleanup
        return () => {
            if (timerRefVisaDenial.current) {
                clearTimeout(timerRefVisaDenial.current)
                timerRefVisaDenial.current = null
            }
        }
    }, [
        city?.sCode,
        city?.dCode,
        tripType,
        query?.depart_date,
        query?.return_date,
        city?.isIntl,
        city?.intl,
        dispatch
    ])

    // Update visa banner when Redux state changes
    useEffect(() => {
        if (isVisaDenialAvailable) {
            setShowVisaBanner(true)
        }
        else {
            setShowVisaBanner(false)
        }
    }, [isVisaDenialAvailable])

    function changeDeparture(event: ChangeEvent<HTMLInputElement>) {
        let arrivalIntl = false
        if (event.target.value.length === 0) {
            departureSearchRef.current = ''
            setloading(false)
            setAirportList({
                ...airportSearchList,
                ['departure']: popularAirports
            })
            if (!isEmpty(arrival)) arrivalIntl = arrival?.split(', ')?.pop()?.trim() !== 'IN'
            setCity({
                ...city,
                arrivalError: false,
                dCode: '',
                destination: '',
                isIntl: arrivalIntl ? 'y' : 'n'
            })
        }
        if (event.target.value.length !== 0)
            setCity({
                ...city,
                sCode: '',
                source: '',
                departureError: false
            })
        const departure = htmlSanitizer(event.target.value)
        departureSearchRef.current = departure
        setDeparture(departure)
        if (departure) {
            debouncedAirportList(departure, 'departure')
        }
    }

    function changeArrival(event: ChangeEvent<HTMLInputElement>) {
        let departureIntl = false
        if (event.target.value.length === 0) {
            arrivalSearchRef.current = ''
            setloading(false)
            setAirportList({
                ...airportSearchList,
                ['arrival']: popularAirports
            })
            if (!isEmpty(departure)) {
                departureIntl = departure?.split(', ')?.pop()?.trim() !== 'IN'
            }
            setCity({
                ...city,
                arrivalError: false,
                dCode: '',
                destination: '',
                isIntl: departureIntl ? 'y' : 'n'
            })
        }
        if (event.target.value.length !== 0) {
            setCity({
                ...city,
                arrivalError: false,
                dCode: '',
                destination: ''
            })
        }
        const arrival = htmlSanitizer(event.target.value)
        arrivalSearchRef.current = arrival
        setArrival(arrival)
        if (arrival) {
            debouncedAirportList(arrival, 'arrival')
        }
    }
    async function airportList(string: string, type: string) {
        let url = getUrlWithArgs(HOME_API_ENDPOINTS.AUTO_SUGGEST, string)
        try {
            setloading(true)
            let searchResult = await baseFetch<ISuggestion[]>({
                url: url,
                method: REQUEST_METHODS.GET,
                domain: getApiDomain()
            })

            //  airportSearch(string)
            if (searchResult) {
                const currentQuery = type === 'departure' ? departureSearchRef.current : arrivalSearchRef.current
                if (currentQuery !== string) {
                    return
                }

                setAirportList(prev => ({
                    ...prev,
                    [type]: searchResult
                }))
                if (type === 'departure') {
                    if (searchResult?.length === 0) {
                        Raven.push({
                            eventName: RAVEN_EVENT_NAME.HOME_DEPARTURE_AIRPORT_NULL_SEARCH,
                            eventData: {
                                action_name: RAVEN_ATTRIBUTE_NAME.HP_DEPARTURE_AIRPORT_NULL_SEARCH,
                                page_name: RAVEN_PAGE_NAME.FLIGHTS_HOME,
                                search_value: string
                            }
                        })
                    }
                } else {
                    if (searchResult?.length === 0) {
                        Raven.push({
                            eventName: RAVEN_EVENT_NAME.HOME_ARRIVAL_AIRPORT_NULL_SEARCH,
                            eventData: {
                                action_name: RAVEN_ATTRIBUTE_NAME.HP_ARRIVAL_AIRPORT_NULL_SEARCH,
                                page_name: RAVEN_PAGE_NAME.FLIGHTS_HOME,
                                search_value: string
                            }
                        })
                    }
                }
            }
        } catch (e) {
            console.log('airportList api error', e)
        } finally {
            setloading(false)
        }
    }

    const debouncedAirportList = useMemo(() => debounce(airportList, 400), [])

    function selectArrival(item: ISuggestion, name: string) {
        let code = item.k
        let value = item.v.split(' -')[0]
        let label = code + ' - ' + value
        let isIntl = value?.split(', ')?.pop()?.trim() !== 'IN'
        setArrival(label)
        let destination = value.split(',')[0]

        let departureIntl = departure?.split(', ')?.pop()?.trim() !== 'IN'
        if (!isEmpty(departure) && departureIntl && !isIntl) {
            isIntl = true
        }
        setIsIntlSelected([value?.split(', ')?.pop()?.trim() !== 'IN', isIntlSelected[1]])
        setCity({
            ...city,
            dCode: code,
            arrivalError: false,
            destination,
            isIntl: isIntl ? 'y' : 'n'
        })
        setToast({
            errorMsg: '',
            closeBtn: true
        })
        Raven.push({
            eventName: RAVEN_EVENT_NAME.HOME_ARRIVAL_AIRPORT_SELECTED,
            eventData: {
                action_name: RAVEN_ATTRIBUTE_NAME.HP_ARRIVAL_AIRPORT_SELECTED,
                page_name: RAVEN_PAGE_NAME.FLIGHTS_HOME
            }
        })
    }
    function selectDeparture(item: ISuggestion) {
        let code = item.k
        let value = item.v.split(' -')[0]
        let label = code + ' - ' + value
        let isIntl = value?.split(', ')?.pop()?.trim() !== 'IN'
        setDeparture(label)
        let source = value.split(',')[0]

        let arrivalIntl = arrival?.split(', ')?.pop()?.trim() !== 'IN'
        if (!isEmpty(arrival) && arrivalIntl && !isIntl) {
            isIntl = true
        }
        setIsIntlSelected([isIntlSelected[0], value?.split(', ')?.pop()?.trim() !== 'IN'])
        setCity({
            ...city,
            source,
            sCode: code,
            departureError: false,
            isIntl: isIntl ? 'y' : 'n'
        })
        setToast({
            errorMsg: '',
            closeBtn: true
        })
        Raven.push({
            eventName: RAVEN_EVENT_NAME.HOME_DEPARTURE_AIRPORT_SELECTED,
            eventData: {
                action_name: RAVEN_ATTRIBUTE_NAME.HP_DEPARTURE_AIRPORT_SELECTED,
                page_name: RAVEN_PAGE_NAME.FLIGHTS_HOME
            }
        })
    }

    const hasDestinationSelected = !isEmpty(city.dCode) || city.destination === 'Anywhere'

    function onAnywhereClick() {
        setArrival('Anywhere')
        setCity({
            ...city,
            destination: 'Anywhere',
            dCode: '',
            arrivalError: false
        })
        setToast({
            errorMsg: '',
            closeBtn: true
        })
    }

    function dateClick(date: { to: string; from: string }) {
        if (date.to) {
            setTripSelect('R')
            setQuery({
                ...query,
                depart_date: getFormattedDate(date.from, 'DD/MM/YYYY'),
                return_date: getFormattedDate(date.to, 'DD/MM/YYYY')
            })
        } else {
            setQuery({
                ...query,
                depart_date: getFormattedDate(date.from, 'DD/MM/YYYY')
            })
        }
    }
    function tripTypeHandler(type: string) {
        setTripSelect(type)
        if (isEmpty(query.depart_date)) {
            setQuery({
                ...query,
                depart_date: getFormattedDate(dayjs().add(2, 'day').toDate(), 'DD/MM/YYYY'),
                return_date: ''
            })
        }
        if (type == 'O') {
            setQuery({
                ...query,
                return_date: ''
            })
            Clevertap.event('Air_UI_Action', {
                action_type: 'BUTTON',
                action_name: ACTION_NAMES.hpRadioOW
            })
        }
        if (type == 'R') {
            Clevertap.event('Air_UI_Action', {
                action_type: 'BUTTON',
                action_name: ACTION_NAMES.hpRadioRT
            })
            if (isEmpty(query.return_date))
                setQuery({
                    ...query,
                    return_date: query.depart_date
                })
        }
    }
    function getUTM(): { [key: string]: string } {
        let searchURL = location.search.split('?')[1] || ''
        const andSepArr = searchURL.split('&').filter(ele => ele.includes('utm_'))
        let utmKeyValPair: string[][] = []

        andSepArr.map(ele => {
            utmKeyValPair.push(ele.split('='))
        })

        let utmObj: { [key: string]: string } = {}
        utmKeyValPair.map(ele => {
            utmObj[ele[0]] = ele[1]
        })

        return utmObj
    }
    function errorHandler(queryObject: srpQueryObject) {
        let validate = false
        let msg = ''
        if (queryObject.from == queryObject.to) {
            msg = 'Departure and arrival airports / cities cannot be same.'
            validate = true
        }

        if (!queryObject.from) {
            msg = 'Enter departure airport / city'
            validate = true
            setCity({
                ...city,
                departureError: true
            })
        }
        if (!queryObject.to) {
            msg = 'Enter arrival airport / city'
            validate = true
            setCity({
                ...city,
                arrivalError: true
            })
        }
        if (!queryObject.from && !queryObject.to) {
            msg = 'Enter departure and arrival airports / cities'
            validate = true
            setCity({
                ...city,
                departureError: true,
                arrivalError: true
            })
        }

        return { validate, msg }
    }
    async function searchHandler() {
        if (isEmpty(city.dCode) && isExploreEnabled) {
            if (!cfwModal && isCfwSelected) {
                setCfwModal(true)
                return
            }
            setToast({
                errorMsg: '',
                closeBtn: false
            })
            const code = city.sCode?.trim().toUpperCase()
            ravenSDKTrigger('a_ui_action', {
                action_name: RAVEN_ATTRIBUTE_NAME.HP_EXPLORE_CLICK,
                action_type: 'click',
                page_name: RAVEN_PAGE_NAME.FLIGHTS_HOME,
            })
            void browserHistory.push({
                pathname: '/flights/explore',
                query: getExploreRouteQuery({
                    source: code,
                    departDate: query.depart_date,
                }),
            })
            return
        }

        const checkIsIntl = !isEmpty(city.isIntl) ? city.isIntl : city.intl
        const statsigExp = Statsig.getExperiment(STATSIG_SPLIT_RT_EXP_NAME)?.get('variant', 'v1') as string

        if (!cfwModal && isCfwSelected) {
            setCfwModal(true)
            return
        }
        const { trafficSource = '' } = getUtmSourceInfo() || {}
        let queryObject: srpQueryObject = {
            ...query,
            from: '',
            to: '',
            intl: '',
            origin: '',
            destination: '',
            sft: '',
            sd: 0,
            rnd_one: '',
            isCfw: false
        }
        queryObject.from = city.sCode
        queryObject.to = city.dCode
        queryObject.intl = city.isIntl || city.intl || ''
        queryObject.origin = departure
        queryObject.destination = arrival
        queryObject.sft = checkIsIntl == 'y' ? (activeFare === 'student' ? activeFare : '') : (activeFare || '')
        //FARE FAMILY TODO: Change this once the cookie logic is solved
        ;(queryObject.sd = new Date().getTime()), (queryObject.rnd_one = tripType)
        queryObject.isCfw = isCfwSelected && isCfwFlow({ isLoginMandatory: false }) ? true : false
        queryObject.nonStop = nonStopFilter ? "true" : undefined
        if (!isEmpty(trafficSource)) {
            queryObject.traffic_source = trafficSource
        }
        const utmObj = getUTM()
        queryObject = { ...queryObject, ...utmObj, isFF : checkIsIntl === 'y' && isNewInternational({statsigExp}) }
        let showToast = errorHandler(queryObject)
        setToast({
            errorMsg: '',
            closeBtn: false
        })

        if (showToast.validate) {
            setToast({
                errorMsg: showToast.msg,
                closeBtn: true
            })
        } else {
            updateHomeSearch({ ...queryObject, sourceCountry: city.source, destinationCountry: city.destination })
            // FARE FAMILY TODO: To remove this function when infra changes are made
            countMetric(
                FUNNEL_SEARCH_CLICKED,
                1,
                getHomeSearchMetricAttributes({
                    isIntl: checkIsIntl,
                    intl: city.intl,
                    tripType,
                    isCfw: queryObject.isCfw,
                })
            )
            replaceQueryInUrl(queryObject)

        }

        const { isIntl, intl } = city || {}
        const { depart_date, return_date, adults, childs, class: travelClass } = query || {}
        const payload = {
            origin: city?.sCode,
            destination: city?.dCode,
            journey_start_date: depart_date,
            journey_return_date: tripType === 'R' ? return_date : 'N/A',
            Adult_Count: adults,
            Child_Count: childs,
            section: 'Flights',
            flight_type: (city.isIntl || city.intl) === 'y' ? 'International' : 'Domestic',
            trip_type: tripType === 'R' ? 'round' : 'single'
        }
        dataLayerGA(payload, ACTION_NAMES.flightSearchClick)

        const ravenPayLoad = {
            action_name: RAVEN_ATTRIBUTE_NAME.HP_SEARCH_FLIGHT,
            page_name: RAVEN_PAGE_NAME.FLIGHTS_HOME,
            a_trip_type: (city.isIntl || city.intl) === 'y' ? 'international' : 'domestic',
            a_journey_type: tripType === 'O' ? 'ow' : 'rt',
            a_fare_type: returnFareName(activeFare),
            a_return_date: tripType === 'R' ? formatDateStandardized(queryObject?.return_date) : 'N/A',
            a_dx: dayDiff(new Date(getFormattedDate(queryObject?.depart_date, 'MM/DD/YYYY', 'DD/MM/YYYY')), new Date()),
            a_adult_count: query.adults || 0,
            a_origin: city?.sCode,
            a_child_count: query.childs || 0,
            a_infant_count: query.infants || 0,
            a_departure_date: formatDateStandardized(queryObject?.depart_date),
            a_destination: city?.dCode,
            // a_srp_ff_cookie : `${ffVar}`
        }
        Raven.push({ eventName: RAVEN_EVENT_NAME.HOME_SEARCH_CLICK, eventData: ravenPayLoad })
    }
    useEffect(() => {
        setIsIntlArray([isIntlSelected[0], isIntlSelected[1]])
    }, [isIntlSelected])

    function isMoreThan24Hours(depart_date: string = "") {
        if(!depart_date) return false
        const [day, month, year] = depart_date?.split("/").map(Number)
        const departDate = new Date(year, month - 1, day)
        const now = new Date();
        const diffInMs = departDate - now;
        const diffInHours = diffInMs / (1000 * 60 * 60);
        return diffInHours > 24; // Returns true if more than 24 hours
    }
    const handleTrackFlightsClick = useCallback(() => {
        const ravenPayload = {
            action_name: "track_flight_status_click",
            action_type: "click",
            page_name: "flights_home",
            a_utm_source: location?.search?.split?.('utm_source=').length > 1
              ? location?.search?.split?.('utm_source=')?.pop()?.split('&')?.[0]
              : getCookie('utm_source') || 'organic',
        }
        ravenSDKTrigger('a_ui_action', ravenPayload)
        browserHistory.push({ pathname: trackingPageConstants.TRACK_FLIGHTS_PATH })
    }, [])

    const specialFaresRowProps = {
        activeFare,
        setActiveFare,
        setIsCfwSelected,
        isCfwSelected,
        cfwModal,
        setCfwModal,
        fareTypeList: fareList,
        tripType,
        variant: 'home' as const,
        searchHandler
    }

    return (
        <>
            <Container className={'flex flex-middle flex-between w-100p'}>
                <Container className='flex flex-middle'>
                    <JourneyType journeyType={tripType} tripTypeHandler={tripTypeHandler} />
                    <div
                        className="divider mr-4 ml-7"
                        style={{
                            backgroundColor: '#E6E6E6',
                            height: 24
                        }}
                    />
                    <TravellerAndClassDropdown
                        activeFare={activeFare}
                        query={query}
                        isIntl={(city.isIntl || city.intl) === 'y'}
                        setQuery={setQuery}
                    />
                </Container>
                <TrackFlightsCTA   
                    label={trackingPageConstants.TRACK_FLIGHTS}
                    imageUrl={trackingPageConstants.TRACK_FLIGHTS_IMAGE_URL}
                    onClick={handleTrackFlightsClick}
                    onRavenImpression={(eventName, payload) => ravenSDKTrigger(eventName, payload)}
                />
            </Container>

            <AirportField
                onArrivalChange={changeArrival}
                onDepartureChange={changeDeparture}
                error={{
                    arrival: city.arrivalError,
                    departure: city.departureError
                }}
                onSelectArrival={selectArrival}
                onSelectDeparture={selectDeparture}
                arrivalList={airportSearchList.arrival}
                departureList={airportSearchList.departure}
                departure={departure}
                arrival={arrival}
                loading={loading}
                departurePlaceholder={'Where from?'}
                arrivalPlaceholder={'Where to?'}
                city={city}
                setCity={setCity}
                setDeparture={setDeparture}
                setArrival={setArrival}
                toast={toast}
                isCfwSelected={isCfwSelected}
                showAnywhereOption={isExploreEnabled}
                onAnywhereClick={onAnywhereClick}
            />

            <Spacer className="mt-6" />
            <Container display={'flex'} flexDirection={'row'} columnGap={'24px'} justifyContent={'space-between'}>
                <Container className={'w-100p'}>
                    <DateRangePicker
                        roundTrip={tripType === 'R'}
                        onwardJourny={departure}
                        returnJourny={arrival}
                        departDate={query?.depart_date || ''}
                        returnDate={query?.return_date || ''}
                        dateClick={dateClick}
                        searchParams={query}
                        toCode={city.dCode}
                        fromCode={city.sCode}
                        journeyType={tripType}
                        showDateFare={true}
                        isCFW={isCfwSelected}
                    />
                </Container>
            </Container>
                <Collapse pose='open'>
                        <Container className="flex flex-row flex-middle my-6">
                            <SpecialFaresRow {...specialFaresRowProps} isIntl={(isIntlArray[0] || isIntlArray[1])} />
                        </Container>
                </Collapse>
                    <Container className="flex flex-row flex-between">
                        <Container className="flex flex-middle">
                            <Container className="flex flex-row flex-middle" style={{ gap: '8px' }}>
                                <ToggleSwitch
                                    isOn={nonStopFilter}
                                    handleToggle={() => setNonStopFilter(!nonStopFilter)}
                                    switchWidth={32}
                                    switchHeight={20}
                                    btnWidth={18}
                                    btnHeight={18}
                                    activeColor="#1a1a1a"
                                    inactiveColor="#808080"
                                />
                                <Container
                                    onClick={() => setNonStopFilter(!nonStopFilter)}
                                    style={{ cursor: 'pointer', color: '#1a1a1a' }}
                                >
                                    <Typography variant="B2" style={{ color: '#1a1a1a' }}>
                                        Non-stop flights only
                                    </Typography>
                                </Container>
                            </Container>
                        </Container>
                        <Button
                    color="secondary"
                    style={{ height: '56px', maxWidth: '280px' }}
                    onClick={searchHandler}
                    className='flex-1'
                    minWidth={"280px"}
                >
                    {hasDestinationSelected || !isExploreEnabled
                        ? EXPLORE_CTA_LABELS.SEARCH_FLIGHTS
                        : EXPLORE_CTA_LABELS.EXPLORE}
                </Button>
                    </Container>
                </>
            
    )
}

export default HomeSearchContainer
